import {
  BillingEntitySelectOptionsDocument,
  type BillingEntitySelectOptionsQuery,
  type BillingEntitySelectOptionsQueryVariables,
} from "@src/__generated__/graphql";
import {
  ContractorSelectOptionsDocument,
  type ContractorSelectOptionsQuery,
  type ContractorSelectOptionsQueryVariables,
} from "@src/__generated__/urql-graphql";
import { FetchHelper } from "@src/helpers/apollo/fetch";
import { client } from "@src/services/client";
import mapToOptions from "@src/utils/map-to-options";
import type { TFilterOptionsQuery, TFilterOptionsQueryArgs } from "./models";

export async function contractorOptionsQuery(
  filters: TFilterOptionsQueryArgs,
): ReturnType<TFilterOptionsQuery> {
  const { data } = await client
    .query<ContractorSelectOptionsQuery, ContractorSelectOptionsQueryVariables>(
      ContractorSelectOptionsDocument,
      filters,
    )
    .toPromise();

  if (!data) return { options: [], paginatorInfo: undefined };

  return {
    options:
      data.contractors?.data.map(({ id, legal_name }) => ({
        value: id,
        label: legal_name,
      })) ?? [],
    paginatorInfo: data.contractors?.paginatorInfo,
  };
}

const billingEntityFetcher = new FetchHelper<
  BillingEntitySelectOptionsQuery,
  BillingEntitySelectOptionsQueryVariables
>(BillingEntitySelectOptionsDocument);
export async function billingEntityOptionsQuery(
  filters: TFilterOptionsQueryArgs,
): ReturnType<TFilterOptionsQuery> {
  const [data, error] = await billingEntityFetcher.fetch(filters, null);

  if (error) return { options: [], paginatorInfo: undefined };

  return {
    options: mapToOptions.billingEntities.toOptions(
      data.billingEntities?.data ?? [],
    ),
    paginatorInfo: data.billingEntities?.paginatorInfo,
  };
}
